import { FeatureCategory } from '../types';

export const dailyLivingFeatures: FeatureCategory = {
  name: "Daily Living Assessments",
  icon: "ClipboardCheck",
  features: [
    { 
      name: "Daily Living Skills", 
      description: "Assessment of Activities of Daily Living including bathing, dressing, eating, and mobility.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Life Skills Check", 
      description: "Instrumental Activities of Daily Living assessment covering cooking, cleaning, managing finances, and transportation.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Timed Up & Go (Mobility)", 
      description: "Simple mobility assessment to evaluate fall risk and movement capabilities.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Vision Test", 
      description: "Basic vision screening tools to monitor eyesight changes and recommend professional care.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Driving Safety", 
      description: "Assessment of driving safety and capabilities with recommendations for continued safe driving.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    }
  ]
};
